// src/js/components/Evaluation/ActionPlan.js
import React, { Component } from "react";
import { connect } from "react-redux";

import './ResultsDownloadForm.css';
import ActionPlanModule from "./ActionPlanModule";

const mapStateToProps = state => {
    return {
        displayresults: state.displayresults,
        outputresults: state.outputresults
    }
}

class ConnectedActionPlan extends Component {
    constructor(props){
        super(props);

        this.scrollToDownloadForm = this.scrollToDownloadForm.bind(this);
    }

    scrollToDownloadForm() {
        let el = document.getElementById('emailresultsform');
        if(el !== undefined) {
            setTimeout(() =>
                    el.scrollIntoView({behavior: "smooth", block: "start", inline: "start"})
                , 50
            );
        } else {
            console.log('error: download form cannot be found');
        }
    }

    render() {
        if (this.props.displayresults) {
            return (
                <div className="evapDownloadContainer" id="actionplan">
                    <div className="evModuleTitleContainer">
                        <div className="evModuleTitle">
                            Plan to act!
                        </div>
                        <div className="evModuleClear"></div>
                    </div>
                    <div className="evResultsContainer">
                        <div>
                            <div className="evThankyouMessage">
                                <p>Completing your questionnaire is only the first step in our evaluation process. Once you have reviewed your results the next step is to plan to act.</p>
                                <p>We do so by developing an interactive action plan containing links to our online support resources as well as providing links to our partners expert resources, services and education programs for ensuring ongoing development.</p>
                                <p>The action plan can be continually reviewed and updated through our online platform, sending timely reminders for completion. Your action plan can then be downloaded for inclusion within board documents for review and development status. </p>
                                <p>For your action plan below, we've taken your responses and utilised these to demonstrate your progress through an example of what our action plans can cover.</p>
                            </div>
                            <div className="evThankyouButton">
                                <BookButton onclick={this.scrollToDownloadForm} formsent={this.props.formsent} />
                            </div>
                            <div className="evModuleClear"></div>
                        </div>
                        <div className="evResultsInnerContainer">
                            <h2>Evaluation Action Plan example</h2>
                            {this.props.outputresults.map((module, index) => <ActionPlanModule key={index} module={module} index={index} />) }
                        </div>
                    </div>
                </div>
            )
        } else {
            return null
        }
    }
}

const ActionPlan = connect(mapStateToProps,null)(ConnectedActionPlan);

export default ActionPlan;

function BookButton(props) {
    if (!props.formsent)
        return <div className="evBookButton" onClick={props.onclick}>Download results and action plan &gt;</div>
    else
        return null
}

